import { j as r } from "./jsx-runtime-DywqP_6a.js";
import { a as e } from "./index-DI5SPFK9.js";
const m = ({
  children: t,
  className: a
}) => /* @__PURE__ */ r.jsx(
  "div",
  {
    className: e("text-sm font-semibold text-primary mb-2", a),
    "data-pagefind-ignore": "all",
    children: t
  }
);
export {
  m as C
};
//# sourceMappingURL=CategoryHeading-BGCNu3VK.js.map
